import { useCallback } from 'react';
import useUserPreferenceId from '~/client/hooks/cookies/useUserPreferenceId';
import useCurrencyCode from '~/client/hooks/currency/useCurrencyCode';
import { useUpdateBtcDisplayTypeMutation } from './UpdateBtcDisplayTypeMutation.generated';

const useToggleBTCDisplayType = () => {
  const [id] = useUserPreferenceId();
  const [updateBtcDisplayType, { loading, error }] =
    useUpdateBtcDisplayTypeMutation();
  const currencyCode = useCurrencyCode();
  const btcDisplayType = currencyCode === 'mBTC' ? 'uBTC' : 'mBTC';

  const toggleBTCDisplayType = useCallback(async () => {
    await updateBtcDisplayType({
      variables: { input: { id, btcDisplayType } },
    });
  }, [btcDisplayType, id, updateBtcDisplayType]);

  return { toggleBTCDisplayType, loading, error };
};

export default useToggleBTCDisplayType;
